import { render, staticRenderFns } from "./UpdatePwdDialog.vue?vue&type=template&id=1a60f1c2&lang=pug&"
import script from "./UpdatePwdDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdatePwdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports